import "@fontsource-variable/inter/wght.css"
import "@fontsource-variable/inter/wght-italic.css"

import "./css/tokens.css"
import "./css/base.css"
import "./css/buttons.css"
import "./css/header.css"
import "./css/hero.css"
import "./css/sections.css"
import "./css/supporters.css"
import "./css/footer.css"

import { initNav } from "./js/nav.js"
import { initReveal } from "./js/reveal.js"
import { initSliders } from "./js/slider.js"
import { initVideos } from "./js/video.js"

function onReady(fn) {
  if (document.readyState !== "loading") fn()
  else document.addEventListener("DOMContentLoaded", fn)
}

onReady(() => {
  initNav()
  initReveal()
  initSliders()
  initVideos()
})

// Nach dem Absenden des Formulars die Dankesmeldung fokussieren (Screenreader)
document.addEventListener("htmx:afterSettle", (e) => {
  e.detail.elt.querySelector?.("[data-autofocus]")?.focus()
})
